<template>
  <div>
    <div class="market-box">
      <div class="all-box">
        <div class="left-box">
          <div
            class="left-item-box"
            :class="{ sel: currType === 1 }"
            @click="typeChange(1)"
          >
            <img
              v-show="currType === 1"
              src="@/assets/img/images/icon/wallet-icon1-s.png"
              alt="wallet-icon1.png"
            />
            <img
              v-show="currType !== 1"
              src="@/assets/img/images/icon/wallet-icon1.png"
              alt="wallet-icon1.png"
            />
            <p>{{ $t("user_assets.web_record.tabTypeValue1") }}</p>
          </div>
          <div
            class="left-item-box"
            :class="{ sel: currType === 2 }"
            @click="typeChange(2)"
          >
            <img
              v-show="currType === 2"
              src="@/assets/img/images/icon/wallet-icon2-s.png"
              alt="wallet-icon1.png"
            />
            <img
              v-show="currType !== 2"
              src="@/assets/img/images/icon/wallet-icon2.png"
              alt="wallet-icon1.png"
            />
            <p>{{ $t("user_assets.web_record.tabTypeValue2") }}</p>
          </div>
        </div>
        <div class="right-box">
          <BoxContent1 v-if="currType === 1" />
          <BoxContent2 v-if="currType === 2" />
        </div>
      </div>
    </div>
    <VFooter />
    <QuestionPopup />
  </div>
</template>

<script>
import VFooter from "@/components/footer/VFooter";
import BoxContent1 from "./components/BoxContent1";
import BoxContent2 from "./components/BoxContent2";
import QuestionPopup from "@/components/QuestionPopup/index";
export default {
  components: {
    VFooter,
    BoxContent1,
    BoxContent2,
    QuestionPopup,
  },
  data() {
    return {
      currType: 1,
    };
  },
  methods: {
    typeChange(val) {
      this.currType = val;
    },
  },
};
</script>

<style lang="less" scoped>
.market-box {
  position: relative;
  background: #f5f6f7;
  padding: 60px 260px 120px 260px;
  .all-box {
    gap: 28px;
    display: flex;
    .left-box {
      padding: 40px;
      width: 420px;
      gap: 20px;
      height: fit-content;
      display: flex;
      flex-direction: column;
      background: #ffffff;
      border-radius: 14px 14px 14px 14px;
      .left-item-box {
        gap: 32px;
        display: flex;
        cursor: pointer;
        padding: 12px 18px;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 22px;
        color: #2c333b;
        img {
          width: 44px;
          height: 44px;
        }
      }
      .sel {
        font-weight: 800;
        font-size: 22px;
        color: #4063ff;
        background: #e1eaff;
        border-radius: 10px 10px 10px 10px;
      }
    }
    .right-box {
      flex: 1;
    }
  }
}
</style>
